import { useDispatch } from "react-redux";
import { getToken, requestChat } from "../services/chatService.js";
import { setLoadingReply, updateExpiredAt } from "../features/messagesSlice.js";
import {
    setDeviceId,
    setCorrId,
    setToken,
    setSKey,
} from "../features/sessionSlice.js";
import {
    setCifId,
    setFullName,
    setIdNumber,
    setMobileNumber,
    setMobIsLogin,
    setPvPbFlag,
} from "../features/userDetailsSlice.js";
import { setIsTypingContainerState } from "../features/componentStateSlice.js";

export default function useRequestData() {
    const dispatch = useDispatch();

    const initializeChat = async () => {
        dispatch(setLoadingReply(true));

        const requestData = await requestChat();

        dispatch(setDeviceId(requestData.deviceId));
        dispatch(setCorrId(requestData.correlation_id));
        dispatch(updateExpiredAt());

        let tokenResponse;

        tokenResponse = await getToken(requestData.correlation_id);

        dispatch(setToken(tokenResponse.token));
        dispatch(setSKey(tokenResponse.s_key));
        dispatch(setFullName(tokenResponse.name));
        dispatch(setMobileNumber(tokenResponse.mobileNumber));
        dispatch(setPvPbFlag(tokenResponse.pvpbFlag));
        dispatch(setCifId(tokenResponse.cid));
        dispatch(setIdNumber(tokenResponse.idNumber));
        dispatch(setIsTypingContainerState(false));
    };

    return { initializeChat };
}
